import * as AdditionalCostMaster from '@/services/rest-api/lib/additional-cost/additional-cost'

const additionalCostTableListFields = [
  {
    name: 'additional_cost_id',
    label: 'Jenis Biaya Tambahan',
    key: 'additional_cost.name',

    type: 'select-resourceful',
    validation: 'required',
    help: true,

    optionsGetter: AdditionalCostMaster.get,
    optionLabelFn: ({ item }) => item?.name,
    getInitialObject: (obj) => obj?.additional_cost,
    customValueFn: (obj) => obj?.additional_cost?.id || null,

    thStyle: 'width: 50%',

    isEditable: true,
  },
  {
    name: 'price',
    label: 'Harga (Rp)',
    key: 'price',
    _type: 'number',
    validation: 'bail|required|number|min:0,value|integer',
    'validation-messages': {
      min: 'Harga tidak boleh minus'
    },
    help: true,
    isEditable: true,
  },
]

export default additionalCostTableListFields
